import { Button, Divider } from "antd"
import Title from "antd/es/typography/Title";

import { LeftOutlined } from '@ant-design/icons';

import Table from "../../../../components/Table";
import useTicketsGroupedByGiveaway from "./useTicketsGroupedByGiveaway";

export default function TicketsGroupedByGiveaway() {
    const {
        columns,
        tableData,
        appUser,
        handleClickGoBack,
        isLoading,
        rowSelection,
        onClickTableRow,
        selectedIds,
        handleClickViewTickets,
    } = useTicketsGroupedByGiveaway();

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    display: 'flex',
                    zIndex: 99,
                    paddingTop: 24,
                    paddingBottom: 10,
                    paddingLeft: 24,
                    paddingRight: 10,
                    margin: -24,
                    alignItems: 'center',
                }}
            >
                <Button
                    type="link"
                    onClick={handleClickGoBack}
                    style={{
                        marginRight: 8,
                    }}
                >
                    <LeftOutlined />
                </Button>

                <Title
                    level={3}
                    style={{
                        margin: 0,
                    }}
                >
                    {appUser?.name}
                </Title>

                <Divider type='vertical' style={{ width: 3, height: 16 }} />

                <Button
                    type="default"
                    style={{ margin: 2 }}
                    onClick={handleClickViewTickets}
                    disabled={selectedIds.length !== 1}
                >
                    Ver bilhetes
                </Button>
            </div>
            <Table
                columns={columns}
                tableData={tableData}
                rowSelection={rowSelection}
                loading={isLoading}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { onClickTableRow(record, rowIndex) }, // click row
                        onDoubleClick: event => { }, // double click row
                        onContextMenu: event => { }, // right button click row
                        onMouseEnter: event => { }, // mouse enter row
                        onMouseLeave: event => { },
                    }
                }}
            />
        </>
    )
}